import { useTheme } from '../contexts/ThemeContext';

const OPTIONS = [
  { id: 'bright', name: 'Bright', description: 'Clean white surfaces with calm blue accents.' },
  { id: 'classic', name: 'Classic', description: 'The original red, blue and gold colours with frosted navy panels.' },
];
export default function ThemePicker() {
  const { theme, setTheme } = useTheme();
  return <section className="glass-surface rounded-2xl p-5 border border-white/5" aria-labelledby="appearance-title">
    <h3 id="appearance-title" className="text-white font-heading font-bold">Appearance</h3>
    <p className="text-zinc-500 text-xs font-body mt-1 mb-4">Choose your Ace It theme. Saved automatically on this browser.</p>
    <div className="ace-theme-options" role="group" aria-label="Colour theme">
      {OPTIONS.map(option => <button key={option.id} type="button" className="ace-theme-choice" aria-pressed={theme === option.id}
        data-testid={`theme-${option.id}`} onClick={() => setTheme(option.id)}>
        <span className={`ace-theme-preview ace-theme-preview-${option.id}`} aria-hidden="true"><i /><span><b /><b /><b /></span></span>
        <span className="ace-theme-choice-title">{option.name}<span aria-hidden="true">{theme === option.id ? '✓' : ''}</span></span>
        <span className="ace-theme-choice-description">{option.description}</span>
      </button>)}
    </div>
    <p className="sr-only" role="status" aria-live="polite">{theme === 'classic' ? 'Classic' : 'Bright'} theme selected.</p>
  </section>;
}
